<template lang="pug">
  .operator-table__filter
    .sorting
      .sorting__button.turquoise(:class="active(1)" @click="sorted(1)") Новые {{ get_count(1) }}
      .sorting__button.blue(:class="active(2)" @click="sorted(2)") В работе {{ get_count(2) }}
      .sorting__button.orange(:class="active(3)" @click="sorted(3)") Подтверждена {{ get_count(3) }}
      .sorting__button.orange.grey Посетил(а)
      .sorting__button.orange.grey Подарок получен
      <!--.sorting__button.orange(:class="active(4)" @click="sorted(4)") В резерве {{ get_count(4) }}-->
      .sorting__button.carrot(:class="active(7)" @click="sorted(7)") Отменено {{ get_count(7) }}
    .action-panel
      .action-panel__info Выбрано {{count}}
      <!--.action-panel__button(@click="action(5)") Отклонить-->
      .action-panel__button(@click="action(3)") Подтвердить
      .action-panel__button(@click="action(2)") В работе
      .action-panel__button(@click="action(4)") В резерве
      .action-panel__button(@click="action(1)") Изменить на новая
</template>

<script>
export default {
  name: "operator-table-filter",
  props: ["count", "status"],
  data() {
    return {
      current_status: null,
    };
  },
  methods: {
    get_count(status) {
      if (this.$props.status.length) {
        let list_ = this.$props.status.filter((i) => {
          return i.status === status;
        });
        return list_.length > 0 ? list_[0].total : 0;
      }
      return 0;
    },
    active(status) {
      return status === this.current_status ? "" : "grey";
    },
    sorted(status) {
      this.current_status = status;
      this.$emit("change", status);
    },
    action(status) {
      this.$emit("action", status);
    },
  },
};
</script>
